function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import BaseVerticalTile from "./BaseVerticalTile";
import PropTypes from "prop-types";
const Compact = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    mediaAspectRatio = "8:5",
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(BaseVerticalTile, _extends({
    mediaAspectRatio: mediaAspectRatio,
    size: "compact"
  }, props, {
    ref: ref
  }));
});
Compact.displayName = "Compact";
Compact.propTypes = {
  /** Where to link to when tile is clicked */
  href: PropTypes.string,

  /** The Icon of the media type the tile is for */
  Icon: PropTypes.func,

  /** Image properties.
   *
   * Note: See eden-image for a list of all available props.
   */
  image: PropTypes.shape({
    /** The image source URL. */
    src: PropTypes.string.isRequired,

    /** The alternate text if the image does not load. */
    alt: PropTypes.string
  }),

  /** Less emphasised heading prefix */
  pretitle: PropTypes.string,

  /** Main heading */
  title: PropTypes.string,

  /** Explaining what the tile is */
  description: PropTypes.string,

  /** Metadata */
  meta: PropTypes.string,

  /** Whether to include light rays on the title */
  lightRays: PropTypes.bool,

  /** Aspect ratio in which you want the image/figure displayed, in the form of n:n (e.g. "1:1", which is square) */
  mediaAspectRatio: PropTypes.oneOf(["1:1", "5:6", "5:8", "6:5", "8:3", "8:5", "16:9"])
};
export default Compact;